var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-collapse',{staticClass:"panel",attrs:{"open":true},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('p',{staticClass:"panel-heading"},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n      ")])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }